export default {
  name: 'App',
  components: {},
  data: function data() {
    return {};
  },
  mounted: function mounted() {}
};